import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

// Initialize theme from localStorage or system settings
const initializeTheme = () => {
  const savedTheme = localStorage.getItem('theme')
  const userSetTheme = localStorage.getItem('theme-user-set')
  
  // If user explicitly set theme, use it
  if (userSetTheme === 'true' && (savedTheme === 'light' || savedTheme === 'dark')) {
    document.documentElement.classList.add(savedTheme)
    return
  }
  
  // Otherwise, follow system preference
  if (typeof window !== 'undefined' && window.matchMedia) {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const theme = prefersDark ? 'dark' : 'light'
    document.documentElement.classList.add(theme)
  } else {
    // Fallback to light if matchMedia is not available
    document.documentElement.classList.add('light')
  }
}

// Initialize theme before rendering
initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            className: 'bg-dark-200 text-white border border-dark-300',
            duration: 4000,
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
) 